import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "template",
  "use": "template-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"template\">\n  <path d=\"M67.2,5H17v90h66V20.8L67.2,5z M78,90H22V10h42.2v14.8H78V90z M74.7,19.8h-5.5v-5.9L74.7,19.8z\" />\n  <rect x=\"27.5\" y=\"66.9\" width=\"45\" height=\"5\" />\n  <rect x=\"27.5\" y=\"54.9\" width=\"45\" height=\"5\" />\n  <rect x=\"27.5\" y=\"42.9\" width=\"45\" height=\"5\" />\n  <rect x=\"27.5\" y=\"30.9\" width=\"45\" height=\"5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol